module.exports = __webpack_public_path__ + "img/empty.f8dab0de.png";